import React from 'react';

import { injectIntl, WrappedComponentProps } from 'react-intl-next';

import {
  EditorAnalyticsAPI,
  INPUT_METHOD,
} from '@atlaskit/editor-common/analytics';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { Transaction } from '@atlaskit/editor-prosemirror/state';
import { SpotlightTarget } from '@atlaskit/onboarding';

import { CodeSuggestionsSpotlight } from './code-suggestions-spotlight';
import { analyticsApiPayload } from './code-suggestions-toolbar-plugin';
import { codeSuggestionsEditModeMessages } from './code-suggestions.i18n';
import { CodeSuggestionsIcon } from './CodeSuggestionsIcon';
import { insertCodeSuggestionNode } from './utils';

type Props = {
  api: any;
} & WrappedComponentProps;

function CodeSuggestionsToolbarButton({ api, intl }: Props) {
  const editorAnalyticsApi: EditorAnalyticsAPI | undefined =
    api?.analytics?.actions;

  return (
    <>
      <CodeSuggestionsSpotlight />
      <SpotlightTarget name="code-suggestions-icon">
        <ToolbarButton
          title={intl.formatMessage(codeSuggestionsEditModeMessages.title)}
          onClick={() => {
            api?.core.actions.execute(({ tr }: { tr: Transaction }) => {
              editorAnalyticsApi?.attachAnalyticsEvent(
                analyticsApiPayload(INPUT_METHOD.TOOLBAR)
              )(tr);
              return insertCodeSuggestionNode(tr);
            });
          }}
          iconBefore={<CodeSuggestionsIcon />}
          aria-label={intl.formatMessage(
            codeSuggestionsEditModeMessages.toolbarButtonLabel
          )}
        />
      </SpotlightTarget>
    </>
  );
}

export default injectIntl(CodeSuggestionsToolbarButton);
